import CryptoJS from "crypto-js";

/**
 * 사용자 비밀번호를 SHA-384 알고리즘으로 해시 처리합니다.
 * - 프론트엔드에서 평문 전송을 방지하기 위한 1차 암호화 용도입니다.
 * - 빈 문자열이 전달될 경우 빈 문자열을 반환하여 불필요한 해시 계산을 피합니다.
 */
export const encryptPassword = (password: string): string => {
  if (!password) {
    return "";
  }

  return CryptoJS.SHA384(password).toString(CryptoJS.enc.Hex);
};